// Home.js
import React from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import NoBlogs from "../components/NoBlogs";

const Blogs = () => {
  return (
    <>
      <Navbar />
      <NoBlogs />
      <Footer />
    </>
  );
};

export default Blogs;
